var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudSkin02ButArrowSet5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow051",
    "data-name": "arrow05",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .arrow05 {\n        /* fill: #333; */\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "arrow05",
    d: "M15.7,43.9c-.9,0-1.8-.3-2.3-1-.6-.7-1-1.5-1-2.4s.4-1.8,1-2.4l8.6-11.6c.8-.8.8-2.1,0-2.9l-8.6-11.6c-.6-.6-1-1.5-1-2.4s.4-1.8,1-2.4,1.5-1,2.4-1,1.8.3,2.4,1l18.5,15.5c.7.6,1,1.5,1,2.4s-.3,1.8-1,2.4l-18.6,15.5c-.6.6-1.5.9-2.4.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSkin02ButArrowSet5);
export default __webpack_public_path__ + "static/media/cloud_skin02_but_arrow_set5.e0083db615b2ab070d91df59556d6e7a.svg";
export { ForwardRef as ReactComponent };